<template>
  <div class="animated fadeIn">
    <div class="tag-section-container">
      <div class="row">
        <div class="col-12 pt-3 pb-2">
          <h3><i class="fas fa-tags"></i> Cadastro de Tags</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pb-3">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="onNew"
            v-b-tooltip.hover
            :title="'Clique para cadastrar'"
          >
            <i class="fas fa-tag"></i> <span class="d-md-down-none">&nbsp; Nova Tag</span>
          </button>
        </div>
      </div>
      <TagList ref="TagList" v-on:New="onNew" v-on:Edit="onEdit"/>
      <TagAddModal ref="TagAddModal" @created="onTagCreated" />
    </div>

    <div class="tag-assign-section-container">
      <div class="row">
        <div class="col-12 pt-3 pb-2">
          <h3><i class="icon-note"></i> Quadros e Tags Vinculados</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12 pb-3">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-on:click="onOpenAssignModal"
            v-b-tooltip.hover
            :title="'Clique para criar nova atribuição'"
          >
            <i class="fas fa-link"></i> <span class="d-md-down-none">&nbsp; Nova Atribuição</span>
          </button>
        </div>
      </div>
      <TagAssignSection ref="TagAssignSection" @open-modal="onOpenAssignModal" @assigned="onTagAssigned" />
      <TagAssignModal ref="TagAssignModal" @assigned="onTagAssigned" />
    </div>
  </div>
</template>
<script>
import TagList from './components/list/taglist.vue'
import TagAddModal from './components/add/TagAddModal.vue'
import TagAssignSection from './components/assign/TagAssignSection.vue'
import TagAssignModal from './components/assign/TagAssignModal.vue'

export default {
  name: 'Tag',
  components: {
    TagList,
    TagAddModal,
    TagAssignSection,
    TagAssignModal
  },
  methods: {
    onLoad () {},
    onNew () {
      this.$refs.TagAddModal.showModal()
    },
    onEdit (obj) {
      this.$refs.TagAddModal.showModal(obj)
    },
    onTagCreated () {
      if (this.$refs.TagList) {
        this.$refs.TagList.onLoad()
      }
    },
    onOpenAssignModal () {
      // Abre o modal vazio para criar nova atribuição
      this.$refs.TagAssignModal.showModal()
    },
    onTagAssigned () {
      // Recarrega a lista de vinculações após atribuir
      if (this.$refs.TagAssignSection) {
        this.$refs.TagAssignSection.onLoad()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/board/tag/tag.vue